import { EQuizMode } from '@constants';

export const StudentQuizTranslations = {
  TEST: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Tests',
    eus: 'Tests',
    pt: 'Testes'
  },
  ANSWERS: {
    es: 'Respuestas',
    en: 'Answers',
    cat: 'Respostes',
    eus: 'Erantzunak',
    pt: 'Respostas'
  },
  CORRECT_AND_SAVE: {
    es: 'Corregir y guardar',
    en: 'Correct and save',
    cat: 'Corregir i desar',
    eus: 'Zuzendu eta gorde',
    pt: 'Corrigir e guardar'
  },
  QUESTIONS: {
    es: 'Preguntas',
    en: 'Questions',
    cat: 'Preguntes',
    eus: 'Galderak',
    pt: 'Perguntas'
  },
  TOTAL: {
    es: 'Total:',
    en: 'Total:',
    cat: 'Total:',
    eus: 'Guztira:',
    pt: 'Total:'
  },
  YOUR_RESPONSES_WILL_BE_SEND: {
    es: 'Se van a enviar tus respuestas.',
    en: 'Your responses will be send.',
    cat: 'Les teves respostes seran enviades.',
    eus: 'Zure erantzunak bidaliko dira.',
    pt: 'As suas respostas serão enviadas.'
  },
  DO_YOU_WANT_TO_CONTINUE: {
    es: '¿Deseas continuar?',
    en: 'Do you want to continue?',
    cat: 'Vols continuar?',
    eus: 'Jarraitu nahi duzu?',
    pt: 'Quer continuar?'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Ezeztatu',
    pt: 'Cancelar'
  },
  CONTINUE: {
    es: 'Continuar',
    en: 'Continue',
    cat: 'Continuar',
    eus: 'Jarraitu',
    pt: 'Continuar'
  },
  [EQuizMode.QUIZ]: {
    es: 'Quiz',
    en: 'Quiz',
    cat: 'Quiz',
    eus: 'Quiz',
    pt: 'Quiz'
  },
  [EQuizMode.PRACTICE]: {
    es: 'Simulacro',
    en: 'Simulator',
    cat: 'Simulacre',
    eus: 'Simulazio',
    pt: 'Simulador'
  },
  [EQuizMode.TRUE_FALSE]: {
    es: 'Verdadero o Falso',
    en: 'True or False',
    cat: 'Veritat o Fals',
    eus: 'Egia edo Derrus',
    pt: 'Verdadeiro ou Falso'
  },
  [EQuizMode.PRACTICAL_CASE]: {
    es: 'Caso Práctico',
    en: 'Practical Case',
    cat: 'Cas Pràctic',
    eus: 'Praktike kasua',
    pt: 'Caso Prático'
  },
  [EQuizMode.LIGHTNING]: {
    es: 'Relámpago',
    en: 'Lightning',
    cat: 'Llampada',
    eus: 'Ikasti',
    pt: 'Relâmpago'
  },
  TIMER_PAUSED: {
    es: '{{mode}} pausado',
    en: '{{mode}} paused',
    cat: '{{mode}} pausat',
    eus: '{{mode}} pausatuta',
    pt: '{{mode}} pausado'
  },
  TIMER_PAUSED_DESCRIPTION: {
    es: 'Pulsa el botón para continuar.',
    en: 'Tap the button to continue.',
    cat: 'Toca el botó per continuar.',
    eus: 'Ezabatu botoa sakatu nahi duzu.',
    pt: 'Toque no botão para continuar.'
  },
  CORRECT_RESPONSES: {
    es: 'Respuestas correctas',
    en: 'Correct answers',
    cat: 'Respostes correctes',
    eus: 'Erantzun zuzenak',
    pt: 'Respostas corretas'
  },
  WRONG_RESPONSES: {
    es: 'Respuestas incorrectas',
    en: 'Wrong answers',
    cat: 'Respostes incorrectes',
    eus: 'Erantzun okerrak',
    pt: 'Respostas incorretas'
  },
  BLANK_RESPONSES: {
    es: 'Respuestas en blanco',
    en: 'Blank answers',
    cat: 'Respostes en blanc',
    eus: 'Erantzun hutsak',
    pt: 'Respostas em branco'
  },
  SCORE: {
    es: 'Nota',
    en: 'Score',
    cat: 'Puntuació',
    eus: 'Puntuazioa',
    pt: 'Pontuação'
  },
  RETRY_QUIZ: {
    es: 'Repetir',
    en: 'Retry',
    cat: 'Repetir',
    eus: 'Errepikatu',
    pt: 'Repetir'
  },
  FINISH_QUIZ: {
    es: 'Finalizar',
    en: 'Finish',
    cat: 'Finalitzar',
    eus: 'Amaitu',
    pt: 'Finalizar'
  },
  REPORT_QUESTION: {
    es: 'Reportar error',
    en: 'Report error',
    cat: "Informar de l'error",
    eus: 'Arazo jakinarazi',
    pt: 'Informar sobre o erro'
  },
  REPORT_TYPE: {
    es: 'Tipo de problema',
    en: 'Problem type',
    cat: 'Tipus de problema',
    eus: 'Arazo mota',
    pt: 'Tipo de problema'
  },
  REPORT_DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  REVIEW_MODE_TITLE: {
    es: 'Modo repaso',
    en: 'Review mode',
    cat: 'Mode repàs',
    eus: 'Berrikusi modua',
    pt: 'Modo de revisão'
  },
  REVIEW_MODE_DESCRIPTION: {
    es: 'Asienta tu conocimiento jugando al modo repaso. Hemos recopilado todos tus fallos en los tests que has realizado para que puedas volver a repasarlos.',
    en: 'Consolidate your knowledge by playing the review mode. We have collected all your failures in the tests you have taken so that you can review them again.',
    cat: 'Consolida el teu coneixement jugant al mode repàs. Hem recopilat tots els teus errors als tests que has fet perquè puguis repassar-los de nou.',
    eus: 'Zure jakintza finkatu berrikusi moduan jokatuz. Egindako testetako erroreak guztira biltzen ditugu berriro ere berrikusteko.',
    pt: 'Consolide o seu conhecimento jogando no modo de revisão. Reunimos todos os seus erros nos testes que fez para que possa rever-los novamente.'
  },
  REVIEW_MODE_CHECK_ALL: {
    es: 'Seleccionar todas',
    en: 'Check all',
    cat: 'Seleccionar totes',
    eus: 'Guztiak hautatu',
    pt: 'Selecionar todos'
  },
  REVIEW_MODE_FAILED_QUESTIONS: {
    es: 'preguntas falladas',
    en: 'failed questions',
    cat: 'preguntes fallades',
    eus: 'galderek huts egin dira',
    pt: 'perguntas falhadas'
  },
  REVIEW_MODE_QUESTIONS: {
    es: 'Preguntas',
    en: 'Questions',
    cat: 'Preguntes',
    eus: 'Galderak',
    pt: 'Perguntas'
  },
  REVIEW_MODE_START_BUTTON: {
    es: 'Comenzar',
    en: 'Start',
    cat: 'Començar',
    eus: 'Hasi',
    pt: 'Iniciar'
  },
  SELECT_ANSWER: {
    es: 'Debes seleccionar una respuesta.',
    en: 'You must select an answer.',
    cat: 'Has de seleccionar una resposta.',
    eus: 'Erantzun bat hautatu behar duzu.',
    pt: 'Você deve selecionar uma resposta.'
  },
  EXIT: {
    es: 'Salir',
    en: 'Exit',
    cat: 'Sortir',
    eus: 'Irten',
    pt: 'Sair'
  },
  EXIT_QUIZ_CONFIRMATION_TITLE: {
    es: '¿Seguro que quieres salir?',
    en: 'Are you sure you want to exit?',
    cat: 'Segur que vols sortir?',
    eus: 'Ziur zaude irtetzeko nahi duzula?',
    pt: 'Tem certeza que deseja sair?'
  },
  EXIT_QUIZ_CONFIRMATION_SUBTITLE: {
    es: 'Perderás el avance de este test.',
    en: 'You will lose the progress of this test.',
    cat: "Perdràs el progrés d'aquest test.",
    eus: 'Proba honetan zure aurrerapena galduko duzu.',
    pt: 'Você perderá o progresso deste teste.'
  },
  HAS_REACHED_MAX_RETRIES: {
    es: 'Has alcanzado el máximo de intentos',
    en: 'You have reached the maximum of retries',
    cat: "Has arribat al màxim d'intents",
    eus: 'Erabiltzaileak errepikatu daitezen den zenbatekoa da',
    pt: 'Você atingiu o máximo de tentativas'
  },
  OPTIONS: {
    es: 'Opciones',
    en: 'Options',
    cat: 'Opcions',
    eus: 'Aukerak',
    pt: 'Opções'
  },
  CORRECT_INSTANTLY: {
    es: 'Corregir al momento',
    en: 'Correct instantly',
    cat: 'Corregir al moment',
    eus: 'Erantzun zuzen al momento',
    pt: 'Corrigir instantaneamente'
  },
  CORRECT_INSTANTLY_DESCRIPTION: {
    es: 'Descubre si acertaste después de contestar cada pregunta.',
    en: 'Discover if you got it right after answering each question.',
    cat: 'Descobreix si has acertat després de contestar cada pregunta.',
    eus: 'Galdera bakoitzari erantzun ondoren ondo asmatu duzun jakiteko.',
    pt: 'Descobrir se acertou depois de responder cada pergunta.'
  },
  SHORTCUT: {
    es: 'Atajo:',
    en: 'Shortcut:',
    cat: 'Atajo:',
    eus: 'Atajo:',
    pt: 'Atajo:'
  },
  USE_THE_ARROWS: {
    es: 'Usa las flechas <a></a> para cambiar de pregunta',
    en: 'Use the arrows <a></a> to change question',
    cat: 'Usa les fletxes <a></a> per canviar de pregunta',
    eus: 'Erantzun bat hautatu behar duzu.',
    pt: 'Use as setas <a></a> para mudar de pergunta'
  },
  LOADING_QUIZ_OPTIONS_1: {
    es: '¡Tú puedes con todo!',
    en: 'You can do it!',
    cat: 'Pots fer-ho!',
    eus: 'Ezin duzu egin!',
    pt: 'Você pode fazer isso!'
  },
  LOADING_QUIZ_OPTIONS_2: {
    es: '¡A por todas!',
    en: 'Go for it!',
    cat: 'Anem!',
    eus: 'Egin!',
    pt: 'Vamos!'
  },
  LOADING_QUIZ_OPTIONS_3: {
    es: '¡Es hora de lucirte!',
    en: "It's time to shine!",
    cat: 'És hora de brillar!',
    eus: 'Ikasti!',
    pt: 'É hora de brilhar!'
  },
  LOADING_QUIZ_OPTIONS_4: {
    es: '¿Listo para brillar?',
    en: 'Ready to shine?',
    cat: 'Pret per brillar!',
    eus: 'Ikasti!',
    pt: 'Pronto para brilhar!'
  },
  LOADING_QUIZ_OPTIONS_5: {
    es: 'Hora de poner a prueba tu cerebro...',
    en: 'Time to test your brain...',
    cat: 'Hora de posar a prova el teu cervell...',
    eus: 'Egiaztatu zure giza...',
    pt: 'Hora de testar o seu cérebro...'
  },
  LOADING_QUIZ_OPTIONS_6: {
    es: 'Despertando neuronas... ¡Al lío!',
    en: 'Waking up neurons... ¡Let´s go!',
    cat: 'Despertant neurones... ¡Anem!',
    eus: 'Neuronaiak despertatzen... ¡Egin!',
    pt: 'Despertando neurônios... ¡Vamos!'
  },
  LOADING_QUIZ_OPTIONS_7: {
    es: '¿Todo listo? ¡Buena suerte!',
    en: 'Are you ready? ¡Good luck!',
    cat: 'Estàs llest? ¡Bon viatge!',
    eus: 'Ez dagozu aldatu dezakezu, baldin eta egin duzu batzuk erantzun.',
    pt: 'Você está pronto? ¡Boa sorte!'
  },
  LOADING_QUIZ_OPTIONS_8: {
    es: 'Hora de demostrar (o fingir) que sabes...',
    en: 'Time to show (or fake) that you know...',
    cat: 'Hora de demostrar (o fingir) que sabes...',
    eus: 'Egiaztatu zure ezagutu duzun...',
    pt: 'Hora de mostrar (ou fingir) que você sabe...'
  },
  LOADING_QUIZ_OPTIONS_9: {
    es: 'Prepárate para brillar… o improvisar',
    en: 'Prepare to shine… or improvise',
    cat: 'Prepareu-vos per brillar… o improvisar',
    eus: 'Ikasti… edo improvisatu',
    pt: 'Prepare-se para brilhar… ou improvisar'
  },

  LOADING_QUIZ_OPTIONS_OPOS: {
    es: '¡A por la plaza!',
    en: "Let's see how you do!",
    cat: 'Anem!',
    eus: 'Egin!',
    pt: 'Vamos!'
  },
  INCORRECT_ANSWER: {
    es: 'Respuesta incorrecta',
    en: 'Incorrect answer',
    cat: 'Resposta incorrecta',
    eus: 'Erantzun okerra',
    pt: 'Resposta incorreta'
  },
  CORRECT_ANSWER_OPTION_1: {
    es: '¡Muy bien!',
    en: '¡Very good!',
    cat: '¡Molt bé!',
    eus: 'Eskubide ona!',
    pt: '¡Muito bem!'
  },
  CORRECT_ANSWER_OPTION_2: {
    es: '¡Excelente!',
    en: '¡Excellent!',
    cat: '¡Excel·lent!',
    eus: 'Eskubide ona!',
    pt: '¡Excelente!'
  },
  CORRECT_ANSWER_OPTION_3: {
    es: '¡Acertaste!',
    en: '¡You got it!',
    cat: '¡Has acertat!',
    eus: 'Eskubide ona!',
    pt: '¡Acertaste!'
  },
  CORRECT_ANSWER_OPTION_4: {
    es: '¡Buen trabajo!',
    en: '¡Good job!',
    cat: '¡Molt bé!',
    eus: 'Eskubide ona!',
    pt: '¡Excelente!'
  },
  CORRECT_ANSWER_OPTION_5: {
    es: '¡Correcto!',
    en: '¡Correct!',
    cat: '¡Correcte!',
    eus: 'Eskubide ona!',
    pt: '¡Excelente!'
  },
  CORRECT_ANSWER_OPTION_6: {
    es: '¡Bien hecho!',
    en: 'Well done!',
    cat: '¡Molt bé!',
    eus: 'Eskubide ona!',
    pt: '¡Excelente!'
  },
  BLANK_ANSWER: {
    es: 'Respuesta en blanco',
    en: 'Blank answer',
    cat: 'Resposta en blanc',
    eus: 'Erantzun hutsa',
    pt: 'Resposta em branco'
  },
  YOU_WONT_BE_ABLE_TO_SWITCH_AFTER_ANSWERING: {
    es: 'No puedes cambiarlo si ya has respondido alguna pregunta.',
    en: "You won't be able to switch it if you have already answered any question.",
    cat: 'No pots canviar-ho si has respost a cap pregunta.',
    eus: 'Ez dagozu aldatu dezakezu, baldin eta egin duzu batzuk erantzun.',
    pt: 'Você não pode alterar isso se já respondeu qualquer pergunta.'
  },
  PAUSE: {
    es: 'Pausar',
    en: 'Pause',
    cat: 'Pausar',
    eus: 'Pausatu',
    pt: 'Pausar'
  },
  YOU_ARE_AMAZING: {
    es: '¡Eres un crack!',
    en: 'You are amazing!',
    cat: 'Ets un crack!',
    eus: 'Eskubide ona!',
    pt: 'Você é incrível!'
  },
  YOU_HAVE_COMPLETED_ALL_AVAILABLE_QUESTIONS: {
    es: 'Has completado todas las preguntas disponibles de los temas que has seleccionado.',
    en: 'You have completed all available questions from the topics you have selected.',
    cat: 'Has completat totes les preguntes disponibles dels temes que has seleccionat.',
    eus: 'Aukeratutako gaiei buruzko galdera guztiak bete dituzu.',
    pt: 'Você completou todas as perguntas disponíveis dos temas que selecionou.'
  },
  SEND_RESPONSES: {
    es: 'Enviar respuestas',
    en: 'Send responses',
    cat: 'Enviar respostes',
    eus: 'Erantzunak bidali',
    pt: 'Enviar respostas'
  },
  TIMER_FINISHED_TITLE: {
    es: '¡Se ha agotado el tiempo!',
    en: 'Time is up!',
    cat: "El temps s'ha acabat!",
    eus: 'Eskubide ona!',
    pt: 'O tempo acabou!'
  },
  TIMER_FINISHED_SUBTITLE: {
    es: 'Revisa cómo te ha ido.',
    en: 'Check how you did.',
    cat: 'Revisa com has fet.',
    eus: 'Egiaztatu nola egin duzun.',
    pt: 'Revise como você fez.'
  },
  SEE_RESULTS: {
    es: 'Ver resultados',
    en: 'See results',
    cat: 'Veure resultats',
    eus: 'Ikusi emaitzak',
    pt: 'Ver resultados'
  },
  READ_CASE: {
    es: 'Lee el caso práctico y responde las preguntas.',
    en: 'Read the practical case and answer the questions.',
    cat: 'Llegeix el cas pràctic i respon a les preguntes.',
    eus: 'Praktike kasua eta galdera erantzun.',
    pt: 'Leia o caso prático e responda as perguntas.'
  },
  DRAFT_QUIZ: {
    es: 'No se pueden asignar tests en borrador',
    en: 'You cannot assign draft quizzes',
    cat: 'No pots assignar tests en borrador',
    eus: 'Ez dagozu testu enborrador batzuk esleitu',
    pt: 'Você não pode atribuir testes em rascunho'
  },
  SHOW: {
    es: 'Mostrar',
    en: 'Show',
    cat: 'Mostrar',
    eus: 'Erakutsi',
    pt: 'Mostrar'
  },
  HIDE: {
    es: 'Ocultar',
    en: 'Hide',
    cat: 'Ocultar',
    eus: 'Ezkutatu',
    pt: 'Ocultar'
  }
};
